import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router/index.js'  // 使用主路由文件
import store from './store'

// 模拟 xlsx 和 file-saver 库
window.XLSX = {
  utils: {
    json_to_sheet: (data) => ({}),
    book_new: () => ({}),
    book_append_sheet: (wb, ws, name) => {}
  },
  write: (wb, opts) => new ArrayBuffer(0)
}

window.FileSaver = {
  saveAs: (data, filename) => {
    console.log(`保存文件: ${filename}`)
  }
}

// 移动设备适配
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
if (isMobile) {
  store.dispatch('app/toggleSideBar') // 在移动设备上默认折叠侧边栏
}

Vue.config.productionTip = false

// 使用 Element UI
Vue.use(ElementUI)

// 确认Vue加载
console.log('Vue loaded:', !!Vue)
console.log('ElementUI loaded:', !!ElementUI)

// 在文件顶部添加
Vue.config.errorHandler = function(err, vm, info) {
  console.error('Vue错误:', err);
  console.error('错误信息:', info);
};

// 简化路由守卫
router.beforeEach((to, from, next) => {
  console.log('路由跳转:', to.path);
  next();
});

// 极简化的应用
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 检查挂载点
console.log('App mount point exists:', !!document.querySelector('#app'))
console.log('Document body:', document.body.innerHTML)

console.log('Vue实例化完成');
